import z from 'zod';

export const zGasApplianceUpdate = z.object({
    hasGasAppliances: z.boolean().nullable(),
    gasApplianceCount: z.union([
        z.literal(0),
        z.literal(1),
        z.literal(2),
        z.null(),
    ]).optional(),
})
    .superRefine((vals, ctx) => {
        if (vals.hasGasAppliances === null) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Required',
                path: ['hasGasAppliances'],
            });
        }

        if (vals.hasGasAppliances === true && vals.gasApplianceCount === undefined) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Required',
                path: ['gasApplianceCount'],
            });
        }
    })
    .transform((vals) => {
        if (vals.hasGasAppliances === false) {
            return {
                hasGasAppliances: false,
                gasApplianceCount: 0,
            };
        }

        return {
            hasGasAppliances: true,
            gasApplianceCount: vals.gasApplianceCount,
        };
    });

export type GasApplianceUpdateFormValues = z.infer<typeof zGasApplianceUpdate>;
